<template>
  <div class="warp">
    <el-table :data="cTableData" ref="table" :max-height="tableHeight" border @sort-change="handlerSort">
      <el-table-column
        v-for="(item, index) in tableCloumn"
        :label="item.label"
        :align="item.align || 'right'"
        :prop="item.prop"
        :sortable="item.custom"
        :key="index"
        :fixed="item.fixed || false"
        :show-overflow-tooltip="true"
        :min-width="item.type === 'inputSelect' ? 200 : item.width ? item.width : 130"
      >
        <template v-for="(o, key) in detailExplail" slot="header">
          <el-popover
            :key="o"
            v-if="item.prop === key && ['3', '4'].includes(info.tax_deduction_status)"
            placement="top"
            trigger="hover"
            slot="label"
          >
            <span slot="reference"> {{ item.label }}<i class="el-icon-question"></i></span>
            <div class="wage-detail-tax">
              {{ $t(o) }}
            </div>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <!-- 编辑状态 -->
          <template v-if="scope.row.edit && item.edit">
            <!-- 下拉框类型 -->
            <el-select v-model="scope.row[item.prop]" :placeholder="$t('221')" v-if="item.type === 'select'">
              <el-option v-for="(i, index) in item.options" :value="i.value" :key="index" :label="i.label"></el-option>
            </el-select>
            <!-- 时间类型 -->
            <el-date-picker
              v-else-if="item.type === 'date'"
              v-model="scope.row[item.prop]"
              :type="(item.rules && item.rules.type) || 'date'"
              :value-format="(item.rules && item.rules.valueFormate) || 'yyyy-MM-dd'"
              :placeholder="$t('839')"
            ></el-date-picker>
            <!-- input类型 -->
            <template v-else>
              <el-input type="text" v-model="scope.row[item.prop]" v-if="item.type === 'inputSelect'">
                <el-select v-model="scope.row[item.childProp]" slot="prepend" :placeholder="$t('221')">
                  <el-option
                    v-for="(i, index) in item.options"
                    :key="index"
                    :label="i.label"
                    :value="i.value"
                  ></el-option>
                </el-select>
              </el-input>
              <template v-else>
                <el-input
                  type="text"
                  v-number="{
                    point: [
                      'day_leave_paid_last',
                      'day_leave_paid_later',
                      'day_leave_not_last',
                      'day_leave_not_later'
                    ].includes(item.prop)
                      ? 4
                      : 2
                  }"
                  v-model="scope.row[item.prop]"
                ></el-input>
                <!-- <el-input-number
                  v-if="['salary_month_fix_tax', 'salary_month_notfix_tax'].includes(item.prop)"
                  v-model="scope.row[item.prop]"
                  :precision="2"
                ></el-input-number>
                <el-input v-else type="text" v-model="scope.row[item.prop]" v-enterNumberPoint2> </el-input> -->
              </template>
            </template>
          </template>
          <!-- 默认文本 -->
          <span v-else>
            {{
              item.type === 'select' ? selectValue(item.options, scope.row[item.prop]) : String(scope.row[item.prop])
            }}</span
          >
        </template>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column fixed="right" :label="$t('70')" v-if="edit" width="180">
        <template slot-scope="scope">
          <!-- 编辑 -->
          <!-- {{ scope.row }} -->
          <el-button type="text" @click="handleClick(scope.row, true, scope)" v-if="!scope.row.edit">{{
            $t('71')
          }}</el-button>
          <!-- 取消和保存 -->
          <el-row v-else>
            <el-button type="text" @click="handleClick(scope.row, false, scope)">{{ $t('66') }}</el-button>
            <el-button type="text" @click="handleClick(scope.row, false, scope, true)">{{ $t('67') }}</el-button>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import '../../../directive.js'
export default {
  props: {
    // 表格是否有操作列
    edit: {
      type: Boolean,
      default: true
    },
    tableData: {
      type: Array,
      default: () => []
    },
    tableCloumn: {
      type: Array,
      default: () => []
    },
    info: {
      type: Object,
      default: () => {}
    }
  },
  title: 'all-info',
  data() {
    return {
      cTableData: this.tableData,
      detailExplail: {
        tax_deduction_7: 'payroll_deduction_all_01',
        tax_deduction_8: 'payroll_deduction_all_02',
        tax_deduction_9: 'payroll_deduction_all_03',
        tax_deduction_10: 'payroll_deduction_all_04',
        tax_deduction_11: 'payroll_deduction_all_05',
        tax_deduction_12: 'payroll_deduction_all_06',
        tax_deduction_13: 'payroll_deduction_all_07',
        tax_deduction_14: 'payroll_deduction_all_08',
        tax_deduction_15: 'payroll_deduction_all_09',
        tax_deduction_16: 'payroll_deduction_all_10',
        tax_deduction_all: 'payroll_deduction_all_0'
      }
    }
  },
  computed: {
    ...mapState({
      contentViewHeight: state => state.settings.contentViewHeight
    }),
    tableHeight() {
      return 500
    }
  },
  watch: {
    tableCloumn(val) {
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
    },
    tableData(val) {
      console.log(val)
      this.cTableData = val
    }
  },
  methods: {
    // 排序
    handlerSort(params) {
      this.$emit('sort', params)
    },
    selectValue(arr, value) {
      const a = arr.filter(i => i.value === value)
      return (a[0] && (a[0].label || a[0].value)) || ''
    },
    handleClick(row, status, scope, save) {
      this.$emit('handleEdit', row, status, scope, save)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-input {
  .el-select {
    width: 70px;
    .el-input {
      width: 70px;
    }
  }
}

/deep/ .el-input-number {
  width: 100%;
  .el-input__inner {
    padding: 0 10px;
  }
  .el-input-number__decrease,
  .el-input-number__increase {
    display: none;
  }
}
</style>
